import { BRACKET_TEAM_ACTION } from "core/constants/Actions";
import { Action } from "core/models/ActionTypes";
import { BracketTeam } from "core/models/Bracket";

const initialState: {
  bracketTeams: BracketTeam[] | null;
  isLoading: boolean;
} = {
  bracketTeams: null,
  isLoading: false,
};

interface ActionType extends Action {
  payload: {
    bracketTeams: BracketTeam[];
  };
}

export default function bracketTeamDetailReducer(
  state = initialState,
  action: ActionType
) {
  switch (action.type) {
    case BRACKET_TEAM_ACTION.REQUEST:
      return { ...state, isLoading: true };

    case BRACKET_TEAM_ACTION.SUCCESS:
      const { bracketTeams } = action.payload;
      return { ...state, bracketTeams, isLoading: false };

    case BRACKET_TEAM_ACTION.FAILURE:
      return { ...state, ...initialState };

    default:
      return state;
  }
}
